module.exports = __webpack_public_path__ + "img/2_EN_ChineseMicrosite_Homepage_HeroImage.791b3868.jpg";